import { render, staticRenderFns } from "./ForwardPreview0.vue?vue&type=template&id=f04a510c&scoped=true"
import script from "./ForwardPreview0.vue?vue&type=script&lang=js"
export * from "./ForwardPreview0.vue?vue&type=script&lang=js"
import style0 from "./ForwardPreview0.vue?vue&type=style&index=0&id=f04a510c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04a510c",
  null
  
)

export default component.exports